export default __webpack_public_path__ + "static/media/line-graph.363016be.svg";